import { Injectable, NgZone } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import * as signalR from '@microsoft/signalr';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { environment } from '@environments/environment';
// import { NotificationResponse } from '@classes/notification/notification-response';
// import { MissionNotification } from '@classes/notification/mission-notification';
import { AuthResponse } from '@classes/auth/auth-response';
import { PaginationRequest } from '@classes/pagination/pagination-request';
import { Pagination } from '@classes/pagination/pagination';
import { NotificationResponse } from '@classes/notification/notification-response';
import { UiService } from './ui.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogNotificationComponent } from '@components/dialog-notification/dialog-notification.component';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  authChanged = new Subject<boolean>();
  notificationsSubject = new Subject<NotificationResponse[]>();
  paginatioNotificationSubject = new BehaviorSubject<Pagination>(null);
  loadingStateChanged = new Subject<boolean>();

  private notifications: NotificationResponse[] = [];

  private signalRConnection: signalR.HubConnection;
  private hubUrl: string = environment.apiUrl + 'hub/notifications';
  private baseUrl: string = environment.apiUrl + 'notifications';
  private connected = false;
  private disconnected = false;
  private identityApiUrl: string = environment.identityApiUrl;

  private tokenKey: string = environment.tokenKey;
  private rfTokenKey: string = environment.rfTokenKey;
  private tokenExpKey: string = environment.tokenExpKey;

  filterValue = null;
  sortValue: string;
  pagination: Pagination;

  constructor(
    private jwtHelperSrv: JwtHelperService,
    private http: HttpClient,
    private uiSrv: UiService,
    private dialog: MatDialog,
    private zone: NgZone
  ) { }

  init(): void {
    this.stop();

    this.signalRConnection = new signalR.HubConnectionBuilder()
      .withUrl(this.hubUrl, {
        // accessTokenFactory: () => this.jwtHelperSrv.tokenGetter(),
        accessTokenFactory: () => {
          return localStorage.getItem(environment.tokenKey);
        }
      })
      // .configureLogging(signalR.LogLevel.Information)
      .build();

    this.signalRConnection.start().then(() => {
      this.connected = true;
      this.disconnected = false;
    });

    this.signalRConnection.onclose((error) => {
      const realThis = this;
      if (!this.disconnected) {
        setTimeout(() => {
          if (realThis.connected) {
            new Promise((resolve, reject) => {
              this.refreshToken().subscribe(() => {
                resolve(true);
              });
            }).then(() => {
              realThis.reconnect();
            });
          }
        }, 5000);
      }
    });

    this.signalRConnection.on("ReceiveMessage", (response: NotificationResponse) => {
      if (response) {
        this.notifications.push(response);
        this.notificationsSubject.next([...this.notifications]);



        if (response.type === 7 && response.payload?.reminder === 2 && response.payload?.orderIdentifier) {
          this.zone.run(() => {
            this.dialog.open(DialogNotificationComponent, {
              maxWidth: "500px",
              data: {
                title: "notifications.dialog.late.title",
                content: "notifications.dialog.late.content",
                orderIdentifier: response.payload.orderIdentifier
              }
            })
          })
        } else {
          this.uiSrv.showSnackbar('Notification reçue.', false);
        }
      }

    })
  }

  checkLocalStorage() {
    if (localStorage.getItem('notifications')) {
      this.notifications = JSON.parse(localStorage.getItem('notifications'));
      this.notificationsSubject.next([...this.notifications]);
    }
  }

  removeOne(index) {
    this.notifications = this.notifications.splice(index + 1, 1);
    this.notificationsSubject.next([...this.notifications]);
  }

  clearNotifications() {
    this.notifications = [];

    localStorage.removeItem('notifications');
  }

  stop(): void {
    this.disconnected = true;
    if (this.connected) {
      this.signalRConnection.stop().then(() => {
        this.connected = false;
      });
    }
  }

  reconnect(): void {
    this.signalRConnection.start().then(() => {
      this.connected = true;
      this.disconnected = false;
    });
  }

  refreshToken(): Observable<AuthResponse> {
    const refreshToken = localStorage.getItem(this.rfTokenKey);
    const httpParams = new HttpParams()
      .append("grant_type", "refresh_token")
      .append("scope", "api offline_access")
      .append("client_id", "web")
      .append("refresh_token", refreshToken);

    return this.http.post<AuthResponse>(this.identityApiUrl + 'connect/token', httpParams)
      .pipe(
        tap(result => {
          this.saveToken(result.access_token, result.refresh_token, result.expires_in);
          this.authChanged.next(true);
        })
      );
  }

  private saveToken(accessToken: string, refreshToken: string, deadline: number): void {
    const tokenExpDate = new Date();
    tokenExpDate.setSeconds(tokenExpDate.getSeconds() + deadline);

    localStorage.setItem(this.tokenExpKey, tokenExpDate.toString());
    localStorage.setItem(this.tokenKey, accessToken);
    localStorage.setItem(this.rfTokenKey, refreshToken);
  }
}
